
import { createSelector } from 'reselect';
import _find from 'lodash/find';
import _merge from 'lodash/merge';

const pickerStreamsSelector = ({ app }) => app.pickerStreams;

export default createSelector(pickerStreamsSelector, (pickerStreams = []) => {
    if (pickerStreams.length > 0) {
        pickerStreams.forEach(item => {
            if (Array.isArray(item.contents) && item.contents.length > 0) {
                item.contents.forEach(content => {
                    // NOTE: Merges first matching nested `stream` object to the parent to ensure we have
                    // all the metadata the players need for UI and playback such as `authTypes` and `packages`
                    if (Array.isArray(content.streams) && content.streams.length > 0 && content.id) {
                        const { id, streams } = content;
                        const matchingStream = _find(streams, { id });

                        if (matchingStream) {
                            _merge(content, matchingStream);
                        }
                    }
                });
            }
        });
    }

    return pickerStreams;
});



// WEBPACK FOOTER //
// ./app/common/selectors/pickerStreamsSelector.js